import styled from 'styled-components';

export const UserTypeWrapper = styled.div`
  display: flex;
`;

export const SupplierTypeWrapper = styled.div`
  margin-left: 20px;
  display: inline;
`;
